export enum RightSidebarRoutes {
	AiChat = 'ai-chat',
	WorkOrder = 'work-order',
	RoutineTemplate = 'routine-template',
}

export enum OpenSidebarEventTypes {
	OpenAiChat = 'open-ai-chat',
	OpenWorkOrder = 'open-work-order',
	OpenRoutineTemplate = 'open-routine-template',
	AttachEntities = 'attach-entities',
}

interface ISidebarOpenEvent {
	type: OpenSidebarEventTypes;
	route: RightSidebarRoutes;
}

export interface OpenAiChatEvent extends ISidebarOpenEvent {
	type: OpenSidebarEventTypes.OpenAiChat;
	route: RightSidebarRoutes.AiChat;
}
export interface OpenWorkOrder extends ISidebarOpenEvent {
	type: OpenSidebarEventTypes.OpenWorkOrder;
	route: RightSidebarRoutes.WorkOrder;
	pk: string;
}
export interface OpenRoutineTemplate extends ISidebarOpenEvent {
	type: OpenSidebarEventTypes.OpenRoutineTemplate;
	route: RightSidebarRoutes.RoutineTemplate;
	pk: string;
}

export interface AttachEntities {
	type: OpenSidebarEventTypes.AttachEntities;
	entityType: 'work_order' | 'incident' | 'request';
}

export type NavigateSidebarEvent = OpenAiChatEvent | OpenWorkOrder | OpenRoutineTemplate;

export type NavigateSidebarSupportEvent = AttachEntities;
